import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import "../Cart/cartitems.css";
import "../OrderFlow/OrderPage.css";
import { ApiKey, baseurl } from "../CoocpeatHome";
import Cookies from "js-cookie";
import DeliveryTypeSection from "./DeliveryTypeSection";
import DeliveryDateSelector from "./DeliveryDateSelector";
import InstantDeliveryModal from "./InstantDeliveryModal";
import CustomerDetailsForm from "./CustomerDetailsForm";
import AddressSection from "./AddressSection";
import AddressComponent from "./AddressSection";
import PhoneAuth from "../component/PhoneAuth";

const CartItems = (locationData) => {
  const navigate = useNavigate();
  const location = useLocation();

  const { selectedAddress, choosen } = location.state || {};
  // console.log(selectedAddress?.location?.address, "location state in cart items");


  const [customerDetails, setCustomerDetails] = useState({
    customerName: "",
    customerLoginMobile: "",
    customerMobile: "",
    customerMailId: "",
    customerAddress: "",
  });

  const [savedAddresses, setSavedAddresses] = useState([]);
  const [newAddress, setNewAddress] = useState("");
  const [deliveryType, setDeliveryType] = useState("instant");
  const [deliveryDate, setDeliveryDate] = useState("");
  const [showCalendar, setShowCalendar] = useState(false);
  const [showInfoModal, setShowInfoModal] = useState(false);
  const [cartData, setCartData] = useState(null);

  const [selected, setSelected] = useState("yes");
  const [newUser, setNewuser] = useState(false);


  const getAddressFromBackend = async () => {
    try {
      const resp = await axios.get(`${baseurl}users/getAddress`, {
        params: { userId: Cookies.get("userId") },
      });
      if (resp.status === 200) setSavedAddresses(resp.data.useraddress || []);
    } catch (error) {
      console.error("Error fetching address:", error);
    }
  };

  const getuserCartItems = async () => {
    try {
      const resp = await axios.get(`${baseurl}users/getUserCartItems`, {
        params: { userId: Cookies.get("userId") },
      });
      if (resp.status === 200) return setCartData(resp.data);
    } catch (error) {
      console.error("Error fetching cart items:", error);
      return [];
    }
  };

  // const result =cartData?.cartItems.reduce((acc, item) => {
  //   // console.log(item, "item in cartData.jsx");
  //   acc[item.productDetails.productId] = item.quantity;
  //   return acc;
  // }, {});
  // console.log( result, "cart items in nanad.jsx");

  useEffect(() => {
    getuserCartItems();
    const currentLocation = JSON.parse(localStorage.getItem("userLocation"));
    console.log(selected, "selected in cart items");
    if (choosen === "no") {
      setNewAddress(selectedAddress || "");
    }
    // } else {
    //   setNewAddress(currentLocation?.address || "");

    // }

  }, [choosen, selectedAddress]);


  const totalqty = cartData?.cartItems?.reduce((sum, item) => sum + item.quantity, 0);
  const startPayment = async (amount) => {
    try {
      const res = await axios.post(
        `${baseurl}payment/createOrder`,
        {
          totalPrice: amount,
          userId: Cookies.get("userId"),
          redirectUrl: baseurl,
        }
      );

      if (res.data?.redirectUrl) {
        window.location.href = res.data.redirectUrl; 
        console.log('working',window.location.href )  // Go → PhonePe Page
      } else {
        alert("Unable to redirect to payment page.");
      }
    } catch (error) {
      console.log(error, "payment_error");
      alert("Payment initialization failed!");
    }
  };

  const handlePlaceOrder = async () => {
    const { customerName, customerMobile, customerMailId } = customerDetails;
    const addressToUse = newAddress || customerDetails.customerAddress;

    if (!customerName || !customerMobile || !customerMailId || !addressToUse) {
      alert("Please fill all customer details.");
      return;
    }

    if (deliveryType === "schedule" && !deliveryDate) {
      alert("Please select delivery date.");
      return;
    }

    const orderProducts = cartData?.cartItems.map((p) => ({
      productId: p.productDetails?.productId,
      productName: p.productDetails?.productname,
      quantity: p.quantity ?? 1,
      price: p.productDetails?.productprice,
    }));

    // Save to localStorage before redirect
    localStorage.setItem("orderProducts", JSON.stringify(orderProducts));
    localStorage.setItem("orderAmount", cartData?.finalTotal);
    localStorage.setItem(
      "customerDetails",
      JSON.stringify({ ...customerDetails, customerAddress: addressToUse })
    );
    localStorage.setItem("deliveryType", deliveryType);
    localStorage.setItem("deliveryDate", deliveryType === "schedule" ? deliveryDate : "");

    await startPayment(cartData?.finalTotal);
  };


  const handleradioChange = (e) => setSelected(e.target.value);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCustomerDetails((prev) => ({ ...prev, [name]: value }));
  };
  const handleAddProduct = () => {
    navigate("/OrderPage", {
      state: {
        id: cartData?.cartItems[0]?.productDetails?.vendorId,
        existingCart: cartData?.cartItems.reduce((acc, item) => {
          acc[item.productDetails.productId] = item.quantity;
          return acc;
        }, {}),
      },
    });
  };

  const handleback = () => {
    navigate(-1, {
      state: {
        id: cartData?.cartItems[0]?.productDetails?.vendorId,
        existingCart: cartData?.cartItems.reduce((acc, item) => {
          acc[item.productDetails.productId] = item.quantity;
          return acc;
        }, {}),
      }
    });
  }

  useEffect(() => {
    getAddressFromBackend();
  }, []);




  return (
    <div className='backcolour'>
      <div className="cart-page">
        <header className="cart-header">
          <img
            src={require("../../asset/CocopeatAssests/Arrow Pointing Left.png")}
            alt="back"
            onClick={() => handleback()}
          />
          <h2 className="fontDG">Cart</h2>
        </header>
        {cartData?.cartItems?.length > 0 ? (
          <div className="cart-content">
            <div className="cart-box">
              <div className="cart-table">
                <div className="cart-row cart-header-row">
                  <p>Product</p>
                  <p>Qty</p>
                  <p>Price</p>
                </div>
                {cartData?.cartItems.map((p) => (
                  <div className="cart-row" key={p.productDetails.productId}>
                    <p className="subpara">{p.productDetails.productname}</p>
                    <p className="subpara">{p.quantity}</p>
                    <p className="subpara">Rs. {p.productDetails.productprice * p.quantity}</p>
                  </div>
                ))}
                <div className="cart-row">
                  <p className="subpara">Taxes & Charges (5%)</p>
                  <p>-</p>
                  <p className="subpara">Rs. {cartData?.taxAmount}</p>
                </div>
                <div className="cart-row">
                  <p className="subpara">Delivery Charges</p>
                  <p>-</p>
                  <p className="subpara">Rs. {cartData?.deliveryCharge}</p>
                </div>
                <div className="cart-row total-row">
                  <p className="total">Total</p>
                  <p>-</p>
                  <p className="total">Rs. {cartData?.finalTotal}</p>
                </div>
              </div>
              <button className="add-btn" onClick={handleAddProduct}>
                Add More Products
              </button>
              {newUser &&
                <PhoneAuth />
              }
              <CustomerDetailsForm customerDetails={customerDetails} handleChange={handleChange} />
              <div className="customer-box">
                <AddressSection
                  selected={selected}
                  setSelected={setSelected}
                  handleradioChange={handleradioChange}
                  savedAddresses={savedAddresses}
                  newAddress={newAddress}
                  setNewAddress={setNewAddress}
                  locationData={locationData}
                />


              </div>
              <div className="customer-box">
                <DeliveryTypeSection
                  deliveryType={deliveryType}
                  setDeliveryType={setDeliveryType}
                  setShowInfoModal={setShowInfoModal}
                />
                {deliveryType === "schedule" && (
                  <DeliveryDateSelector
                    deliveryDate={deliveryDate}
                    setDeliveryDate={setDeliveryDate}
                    showCalendar={showCalendar}
                    setShowCalendar={setShowCalendar}
                  />
                )}
                {showInfoModal && <InstantDeliveryModal setShowInfoModal={setShowInfoModal} />}
              </div>
            </div>
            {totalqty > 0 && (
              <div className="cart-section">
                <div className="cart-total">
                  <p className="discounted-price">Rs. {cartData?.finalTotal}</p>
                </div>
                <div className="cart-actions">
                  <div className="cart-items">{totalqty} pcs</div>
                  <button className="go-cart-button" onClick={handlePlaceOrder}>
                    Place Order
                  </button>
                </div>
              </div>
            )}
          </div>
        ) : (
          <p className="emptyproduct">Add Products to See the Cart</p>
        )}
      </div>
    </div>

  );
};

export default CartItems;
